import React from "react"

const ViewportContext = React.createContext(null)
export { ViewportContext }
